"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStatusSuccess16(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '1rem', height: '1rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
        React.createElement("path", { d: "M8 15.001a7.009 7.009 0 01-7-7 7.009 7.009 0 017-7 7.009 7.009 0 017 7 7.009 7.009 0 01-7 7zm-.6-4.036a.376.376 0 00.105.014.51.51 0 00.354-.147l4.242-4.243a.508.508 0 000-.708l-.564-.565a.5.5 0 00-.355-.148.49.49 0 00-.354.148L7.4 8.745 5.386 6.727a.508.508 0 00-.355-.145.5.5 0 00-.354.145l-.564.565a.489.489 0 00-.146.359.48.48 0 00.146.349l2.826 2.832a.489.489 0 00.354.144.573.573 0 00.107-.01z" })));
}
var ForwardRef = React.forwardRef(SvgStatusSuccess16);
exports.default = ForwardRef;
